// extracted by mini-css-extract-plugin
export default {"card":"Clubs-Social-Links_card__l7nh2"};